<div
    class="navbar-option"
    *ngIf="appsEnabled.length > 0"
    (mouseenter)="showTooltip = true"
    (mouseleave)="showTooltip = false"
>
    <div class="dropdown">
        <div class="dropdown-toggle" data-toggle="dropdown">
            <img
                appImageSelector
                alt="mt-image"
                [imageType]="'icon'"
                [imageKey]="'change-system'"
            />
        </div>

        <div class="dropdown-menu dropdown-menu-right">
            <div class="change-app">
                <div class="title">
                    {{ "select_another_system" | lang | uppercase }}
                </div>

                <div class="application" *ngFor="let app of appsEnabled">
                    <object
                        appImageSelector
                        [imageType]="'icon'"
                        [imageKey]="'logo-change-system'"
                    ></object>
                    <div class="app-name">{{ app.name }}</div>
                </div>
            </div>
        </div>
        <label
            *ngIf="showTooltip"
            [attr.tooltip]="'select-other-system' | lang"
            tooltip-position="bottom"
            class="label-tooltip"
        ></label>
    </div>
</div>
